import React from "react";

import Head from "components/Head";
import EmbededVideo from "components/Embeds/Video";
import { HOST_URL, DEFAULT_SSG_LIMIT } from "config/constants";
import { prepareSlugsArray } from "../../../helpers/apiRevalidateHelper";

const apiPrivateUrl = process.env.apiPrivateUrl;

export default function VideoEmbed(props) {
  return (
    <>
      <Head>
        <title>{`${props.newsItem.item.title} - Real America's Voice News`}</title>
        <meta name="robots" content="noindex" />
        <link rel="canonical" href={`${HOST_URL}/${props.slug}/`} />
        <meta
          name="description"
          content="Real America's Voice News is your one stop news and entertainment network."
        />
        <meta property="og:type" content="video.tv_show" />
        <meta
          name="og:title"
          content={`${props.newsItem.item.title} - Real America's Voice News`}
        />
        <meta
          name="og:description"
          content="Real America's Voice News is your one stop news and entertainment network."
        />
        <style
          dangerouslySetInnerHTML={{
            __html: `
          body {
            overflow: hidden;
          }
          #iframeChat {
            display: none !important;
          }
        `,
          }}
        />
      </Head>
      <EmbededVideo
        video={props.newsItem.item.video}
        title={props.newsItem.item.title}
      />
    </>
  );
}

export async function getStaticPaths() {
  const res = await fetch(
    `${apiPrivateUrl}/news?limit=${DEFAULT_SSG_LIMIT}&slugsonly=true`
  );
  const data = await res.json();
  const paths = prepareSlugsArray(data);

  return { paths, fallback: "blocking" };
}

export async function getStaticProps(context) {
  const slug = encodeURIComponent(context.params.slug.join("/"));
  const apiEndpoints = [`${apiPrivateUrl}/news/${slug}`];

  try {
    const [newsItem] = await Promise.all(
      apiEndpoints.map((endpoint) =>
        fetch(endpoint)
          .then((response) => response.json())
          .catch((error) => console.error(error))
      )
    );

    if (!newsItem?.item) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        slug,
        newsItem,
      },
      revalidate: 60,
    };
  } catch (e) {
    console.group("pages/embed/video/[...slug].jsx - getStaticProps");
    console.log(e);
    console.groupEnd();

    return {
      notFound: true,
    };
  }
}
